import { createFileRoute } from '@tanstack/react-router';

import { PageHeader } from '@/components/ui.tsx';
import { useAuth } from '@/store/auth.ts';
import { AwardsWallView } from '@/views/awards/awards-wall-view.tsx';

// ADR-022: student award wall (badges + certificates). The Next app wrapped this
// in a max-w-6xl PageHeader layout; inline that wrapper here (single page).
export const Route = createFileRoute('/_learner/awards')({
  component: AwardsPage,
});

function AwardsPage() {
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return (
    <div className="mx-auto max-w-6xl px-6 py-10">
      <PageHeader title="My Awards" subtitle="Badges and certificates you've earned." />
      <div className="mt-8">
        <AwardsWallView />
      </div>
    </div>
  );
}
